import { BaseShortcut } from '@shared/directives/shortcuts/base-shortcut';
import { Directive, Output, OnDestroy, EventEmitter } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { Annotation } from '@shared/models';
import { v4 as uuid } from 'uuid';

@Directive({
  selector: 'copy-paste-shortcut-directive',
  outputs: ['copyRequested', 'pasteRequested', 'clipboardedAnnotationChanged']
})
export class CopyPasteShortcutDirective extends BaseShortcut implements OnDestroy {
  @Output() copyRequested = new EventEmitter<any>();
  @Output() pasteRequested = new EventEmitter<any>();
  @Output() clipboardedAnnotationChanged = new EventEmitter<Annotation>();

  clipboardedAnnotation: Annotation;

  constructor(private _dialog: MatDialog) {
    super();
  }

  ngOnDestroy(): void {
    this.setClipboardedAnnotation(null);
    super.ngOnDestroy();
  }

  setClipboardedAnnotation(annotation: Annotation): void {
    this.clipboardedAnnotation = annotation;
    this.clipboardedAnnotationChanged.emit(this.clipboardedAnnotation);
  }

  cloneAnnotation(origin: Annotation): Annotation {
    return JSON.parse(JSON.stringify(origin));
  }

  copyAnnotation(annotation: Annotation): void {
    if (annotation) {
      this.setClipboardedAnnotation(this.cloneAnnotation(annotation));
    }
  }

  duplicateAnnotation(): Annotation {
    if (!this.clipboardedAnnotation) {
      return;
    }
    const clone = this.cloneAnnotation(this.clipboardedAnnotation);
    // Set a new action id for annotation main action
    if (clone.properties.action) {
      clone.properties.action.id = uuid();
    }
    // For quiz annotations, set new action id's for every possibly defined action independently of the type
    if (clone.properties.quiz) {
      updateActionIds(clone.properties.quiz);
    }
    delete clone.id;
    delete clone.media;
    delete clone.properties.snapZoneId;

    return clone;
  }

  onKeyPress($event: KeyboardEvent): void {
    if (document.activeElement.nodeName === 'TEXTAREA' || document.activeElement.nodeName === 'INPUT') {
      return;
    }
    if (($event.ctrlKey || $event.metaKey) && $event.keyCode === 67) {
      this.copyRequested.emit();
    }
    if (($event.ctrlKey || $event.metaKey) && $event.keyCode === 86) {
      this.pasteRequested.emit();
    }
  }

  filterEvent(event: any): void {}
}

// Deep search an object for the action property, and change it's id if it has one
function updateActionIds(obj: any): void {
  if (!obj || typeof obj !== 'object') return;

  if ('action' in obj && obj.action?.id) {
    obj.action.id = uuid();
  }

  for (const key of Object.keys(obj)) {
    const value = obj[key];
    if (Array.isArray(value)) {
      value.forEach(updateActionIds);
    } else if (typeof value === 'object' && value !== null) {
      updateActionIds(value);
    }
  }
}
